import { gql } from "@apollo/client"

// Fragments

const SKU_FRAGMENTS = {
  skuDetail: gql`
    fragment SkuDetailFrag on SKUGraphType {
      id
      name
      description
      capacity
      createdAt
      dimensions
      unitPrice
      isReturnable
      metadata
      dimensionUnit {
        id
        name
        codename
      }
      skuCategory {
        id
        name
        codename
      }
      capacityUnit {
        id
        name
        codename
      }
      stockCount
      selfWeight
    }
  `,
}
const SKUS_LIST = gql`
  query allSkuTypesList($query: String, $first: Int, $skip: Int) {
    allSkuTypes(query: $query, first: $first, skip: $skip) {
      ...SkuDetailFrag
    }
  }
  ${SKU_FRAGMENTS.skuDetail}
`

const SKU_DETAILS = gql`
  query skuDetails($id: Int!) {
    skuDetails(skuId: $id) {
      ...SkuDetailFrag
    }
  }
  ${SKU_FRAGMENTS.skuDetail}
`

const ADD_SKU = gql`
  mutation addSkutype(
    $id: ID
    $capacity: Float
    $capacityUnit: Int
    $description: String
    $name: String
    $selfWeight: Float
    $stockCount: Int
    $skuCategory: ID
    $dimensionUnit: ID
    $dimensions: [Float]
    $isReturnable: Boolean
    $unitPrice: Float
    $metadata: JSONString
  ) {
    addUpdateSkuType(
      id: $id
      capacity: $capacity
      capacityUnitId: $capacityUnit
      isReturnable: $isReturnable
      unitPrice: $unitPrice
      name: $name
      description: $description
      selfWeight: $selfWeight
      stockCount: $stockCount
      skuCategoryId: $skuCategory
      dimensionUnitId: $dimensionUnit
      dimensions: $dimensions
      metadata: $metadata
    ) {
      skuType {
        ...SkuDetailFrag
      }
    }
  }
  ${SKU_FRAGMENTS.skuDetail}
`

export { SKUS_LIST, SKU_DETAILS, ADD_SKU }
